import React, { useState, useEffect, useRef } from 'react';
import NewNavbar from '../NewNavbar';
import './homepage.css';

const WORDS = ['care', 'service'];
const TYPE_SPEED = 100;
const DELETE_SPEED = 60;
const PAUSE_MS = 1800;

const HeroSection = () => {
  const [displayed, setDisplayed] = useState('');
  const [wordIdx, setWordIdx] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const currentWord = WORDS[wordIdx];

    if (!isDeleting && displayed === currentWord) {
      timeoutRef.current = setTimeout(() => setIsDeleting(true), PAUSE_MS);
      return;
    }

    if (isDeleting && displayed === '') {
      setIsDeleting(false);
      setWordIdx((prev) => (prev + 1) % WORDS.length);
      return;
    }

    const delay = isDeleting ? DELETE_SPEED : TYPE_SPEED;
    timeoutRef.current = setTimeout(() => {
      setDisplayed(isDeleting
        ? currentWord.slice(0, displayed.length - 1)
        : currentWord.slice(0, displayed.length + 1)
      );
    }, delay);

    return () => clearTimeout(timeoutRef.current);
  }, [displayed, isDeleting, wordIdx]);

  return (
    // Passed as a custom property, not background-image: an inline
    // background-image would beat the media query that hides the banner
    // on mobile.
    <section
      className="hp-hero"
      style={{ '--hero-bg': "url('/assets/images/home-banner.png')" }}
    >
      <div className="hp-hero__navbar-wrap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <NewNavbar />
            </div>
          </div>
        </div>
      </div>
      <div className="hp-hero__content">
        <div className="hp-hero__inner">
          <h1 className="hp-hero__heading">
            Passionate <br />
            about{' '}
            <span className="hp-hero__heading-accent">
              {displayed}
              <span className="hp-hero__cursor">|</span>
            </span>
          </h1>
          <h2 className="hp-hero__heading-mobile">
            Passionate<br />about you
          </h2>
          <p className="hp-hero__subtext">
            Our approach blends expertise and personalisation, offering tailored
            online and in-clinic healthcare. From prescriptions to blood tests,
            we strive to deliver exceptional customer service every step of the way.
          </p>
          <a href="#our-services" className="hp-hero__btn">
            View our services
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
